import React, { useState } from "react";
import { Map } from "lucide-react";
import { GuidedTour, q } from "@/components/GuidedTour";
import { useL } from "@/lib/useL";

const STEPS = [
  { el: () => q("flip-card"), fr: ["1 · Lisez la question", "Essayez de répondre dans votre tête, puis touchez la carte pour la retourner et voir la réponse."], en: ["1 · Read the question", "Try to answer in your head, then tap the card to flip it and see the answer."] },
  { el: () => q("flashcard-again-btn")?.parentElement, fr: ["2 · Dites si vous saviez", "« Je savais » : la carte revient plus tard (demain, puis 3 jours, puis 1 semaine). « À revoir » : elle revient à la fin de la séance."], en: ["2 · Say if you knew it", "« I knew it »: the card comes back later (tomorrow, then 3 days, then 1 week). « Review again »: it comes back at the end of the session."] },
  { el: () => q("flashcard-nav"), fr: ["3 · Passez d'une carte à l'autre", "Utilisez les flèches ou glissez la carte avec le doigt. « Mélanger » change l'ordre des cartes."], en: ["3 · Move between cards", "Use the arrows or swipe the card with your finger. « Shuffle » changes the card order."] },
  { el: () => q("flashcard-share-btn")?.parentElement?.parentElement, fr: ["4 · Imprimez ou partagez", "Imprimer : PDF à découper, gratuit. + 10 cartes : nouvelles questions (1 crédit). Partager : un lien et un QR code pour que les élèves révisent sur leur téléphone, sans compte."], en: ["4 · Print or share", "Print: cut-out PDF, free. + 10 cards: new questions (1 credit). Share: a link and QR code so pupils review on their phone, no account needed."] },
];

// On-demand guided tour of the flashcard study page.
export function FlashcardsTour() {
  const L = useL();
  const [open, setOpen] = useState(false);
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} data-testid="flashcards-tour-btn"
        className="font-mono uppercase tracking-[0.2em] text-[10px] border border-[#002FA7] text-[#002FA7] dark:border-blue-400 dark:text-blue-300 px-3 py-2 hover:bg-[#002FA7] hover:text-white transition-colors flex items-center gap-2">
        <Map className="w-3 h-3" /> {L("Visite guidée", "Guided tour")}
      </button>
      <GuidedTour open={open} onClose={() => setOpen(false)} steps={STEPS} onStart={() => {}} />
    </>
  );
}

export default FlashcardsTour;
